import React from "react";

const levels = [
  { level: 1, revenue: 50, turnover: 2.0, deposits: "0–14" },
  { level: 2, revenue: 55, turnover: 2.5, deposits: "15–49" },
  { level: 3, revenue: 60, turnover: 3.0, deposits: "50–99" },
  { level: 4, revenue: 65, turnover: 3.5, deposits: "100–199" },
  { level: 5, revenue: 70, turnover: 4.0, deposits: "200–399" }, // Current level
  { level: 6, revenue: 75, turnover: 4.5, deposits: "400–699" },
  { level: 7, revenue: 80, turnover: 5.0, deposits: "700+" },
];

export default function AffiliateLevelsModal({
  open,
  onClose,
  currentLevel = 5,
  currentDeposits = 178,
}) {
  if (!open) return null;

  const thisLevel = levels.find((l) => l.level === currentLevel);
  const [, max] = thisLevel.deposits.split("–").map((v) => parseInt(v, 10));
  const maxForBar = max || currentDeposits;
  const percent = Math.min(
    100,
    Math.round((currentDeposits / maxForBar) * 100)
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 backdrop-blur-sm">
      <div className="relative w-full max-w-2xl overflow-hidden rounded-[32px] border border-white/10 bg-[rgba(11,18,31,0.98)] p-7 shadow-[0_30px_90px_rgba(0,0,0,0.4)]">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-2xl border border-white/10 bg-white/[0.05] px-3 py-2 text-white"
          aria-label="Close"
        >
          Close
        </button>
        <div className="flex items-center gap-4 mb-2">
          <span className="text-4xl">🏆</span>
          <div>
            <div className="text-lg font-bold text-white">Affiliate Levels</div>
            <div className="text-sm text-slate-400">
              Increase the number of deposits and get more profit with us!
            </div>
          </div>
        </div>
        <div className="mt-4">
          <table className="w-full text-sm text-left">
            <thead>
              <tr className="text-slate-500">
                <th className="py-2">Name</th>
                <th className="py-2 font-semibold">Revenue</th>
                <th className="py-2 font-semibold">Turnover</th>
                <th className="py-2 font-semibold">Deposits</th>
              </tr>
            </thead>
            <tbody>
              {levels.map((level) => {
                const isCurrent = level.level === currentLevel;
                return (
                  <tr
                    key={level.level}
                    className={`transition ${
                      isCurrent ? "bg-white/[0.05] font-semibold" : ""
                    }`}
                  >
                    <td className="py-2">
                      {isCurrent ? (
                        <div>
                          <div className="mb-0.5 text-xs text-emerald-300">YOUR POSITION:</div>
                          <span className="font-bold text-white">Level {level.level}</span>
                        </div>
                      ) : (
                        <span className="font-semibold text-slate-300">Level {level.level}</span>
                      )}
                    </td>
                    <td className="py-2">{level.revenue}</td>
                    <td className="py-2">{level.turnover.toFixed(1)}</td>
                    <td className="py-2">{level.deposits}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="px-4 pb-3">
            <div className="flex items-center gap-2 mt-2">
              <span className="text-xs text-slate-400">
                <span className="font-bold text-emerald-300">⚡ {currentDeposits} DEPOSITS</span>
                {maxForBar ? ` / ${maxForBar}` : ""}
              </span>
            </div>
            <div className="mt-1 h-2 w-full rounded-full bg-white/10">
              <div
                className="h-2 rounded-full bg-[var(--aff-accent)] transition-all"
                style={{ width: `${percent}%` }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
